import React from 'react';
import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

function ChargerPlanningDashboard() {
    const [cardRef, isCardVisible] = useScrollAnimation({ threshold: 0.2, triggerOnce: true });

    return (
            <main className="bg-gray-50 transition-all duration-300 ease-in-out min-h-[125vh]">
        <div className="p-8 max-w-7xl mx-auto">
          <div
            ref={cardRef}
            className={`bg-white rounded-xl shadow-lg p-10 mt-[5vh] transition-all duration-1000 ease-out transform ${
              isCardVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <h1 className="w-full text-center text-4xl font-bold text-gray-800 pb-6 font-ui">
              Welcome to the AmpTrans ChargerPlan
            </h1>
            
            <p className="text-lg text-gray-700 leading-relaxed pb-5 font-ui">
              Your smart tool for identifying the best locations to install the next charging station. Eliminate the headache of manually searching through land parcels, digging through historical records, and trying to figure out which parcels are best suited for charging stations.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed pb-5 font-ui">
                Everything you need to know about a land parcel is in one place. Points of interest nearby, zoning information, trucking hotspots, and more are all available simultaenously so you can see 
                the entire context.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed pb-5 font-ui">
              Getting started is simple:
            </p>
            
            <ol className="list-decimal pl-6 mb-6 space-y-3 font-ui text-lg text-gray-700 leading-relaxed">
              <li>Start by visiting the <strong>Browse</strong> page to view the list of land parcels.</li>
              <li>You can filter for parcels that you are interested in, or use the <strong>Search Preferences</strong> to find the best parcels for your needs.</li>
              <li>Check out the <strong>Compare</strong> page to see the details of the parcels you are interested in.</li>
            </ol>

            <p className="text-lg text-gray-700 leading-relaxed pb-5 font-ui">
              Our platform is continuously improving, and we have a lot more features coming soon. If you have any questions or feedback, feel free to reach out to us at{' '}
              <a 
                href="mailto:info@amptrans.net"
                className="text-blue-600 font-medium transition-colors duration-200 hover:text-blue-700 hover:underline"
              >
                info@amptrans.net
              </a>, and stay tuned for upcoming updates.
            </p>
            
            <div className="mt-6 flex justify-center">
              <Link to="/charger/browse">
                <button className="btn-primary btn-lg font-ui">
                  Get Started Now
                </button>
              </Link>
            </div>
          </div>
        </div>
      </main>
    );
}

export default ChargerPlanningDashboard;